import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-other-state-pincodewise-statement',
  templateUrl: './other-state-pincodewise-statement.component.html',
  styleUrls: ['./other-state-pincodewise-statement.component.scss'],
})
export class OtherStatePincodewiseStatementComponent implements OnInit {
  mumbaipincodewisedata;
  thanepincodewisedata;
  jilhapincodewisedata;
  otherstatepincodewisedata;
  total_pin_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  total_mumbai_pin_sub_count = 0;
  totalmumbaiparcel = 0;
  totalmumbaianksankhya = 0;
  total_thane_pin_sub_count = 0;
  totalthaneparcel = 0;
  totalthaneanksankhya = 0;
  total_dist_pin_sub_count = 0;
  totaldistparcel = 0;
  totaldistanksankhya = 0;
  filteredotherstatepincodewisedata = [];
  pincodewisesubcoutprinting = [];
  sundayankDate;
  dispatchankDate;

  constructor(
    private dialogref: MatDialogRef<OtherStatePincodewiseStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }
  updateStatus: any
  issuedate: any
  state: any
  district: any
  deleveryMode: any
  country: any
  distributionMode: any
  subDistributionMode: any
  taluka: any
  type: any
  pincode: any
  ngOnInit(): void {
    this.mumbaipincodewisedata = this.data['data'].filter(
      (a) => a['state'] === 'महाराष्ट्र' && a['district'] === 'मुंबई'
    );
    this.thanepincodewisedata = this.data['data'].filter(
      (a) => a['state'] === 'महाराष्ट्र' && a['district'].trim() === 'ठाणे'
    );
    let data = this.data['data']
      .filter((a) => a['state'] === 'महाराष्ट्र')
      .filter((a) => a['district'] !== 'मुंबई');
    this.jilhapincodewisedata = data.filter(
      (a) => a['district'].trim() !== 'ठाणे'
    );
    this.otherstatepincodewisedata = this.data['data'].filter(
      (a) => a['state'] !== 'महाराष्ट्र'
    );
    this.sundayankDate = this.data['sundaydate'];
    this.dispatchankDate = this.data['dispatchdate'];
    this.updateStatus = this.data['updateStatus']
    this.issuedate = this.data['issuedate']
    this.state = this.data.state;
    this.district = this.data.district;
    this.deleveryMode = this.data['deleveryMode'];
    this.country = this.data.country;
    this.distributionMode = this.data.distributionMode;
    this.subDistributionMode = this.data.subDistributionMode;
    this.type = this.data.type;
    this.taluka = this.data.taluka;
    this.pincode = this.data.pincode;
    if (this.issuedate == undefined) {
      alert("Please Select Issue Date !!");
    }
    if (this.dispatchankDate == undefined) {
      alert("Please Select Dispatch Date!!");
    }
    if (this.updateStatus) {
      // this.getAllDistributerCopiesList(); // Old Code 
      this.get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement();
    } else {
      this.getOtherStatePincodewiseStatementList();
    }

  }

  getDistrictwiseStatement() {
    this.total_dist_pin_sub_count = 0;
    this.totaldistparcel = 0;
    this.totaldistanksankhya = 0;
    let tempdata = this.uniqueid(
      this.jilhapincodewisedata,
      (a) => a['district']
    );

    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.jilhapincodewisedata.filter(
        (a) => a['district'] == tempdata[index]['district']
      );

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );

        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );

          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval += hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
          }
        }
      }

      this.total_dist_pin_sub_count += totalTapalCount;
      this.totaldistparcel += parcelval;
      this.totaldistanksankhya += anksankhya;
    }
  }

  getThanePincodeStatement() {
    this.total_thane_pin_sub_count = 0;
    this.totalthaneparcel = 0;
    this.totalthaneanksankhya = 0;
    let tempdata = this.uniqueid(
      this.thanepincodewisedata,
      (a) => a['pincode']
    );

    // console.log({ tempdata });
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.thanepincodewisedata.filter(
        (a) => a['pincode'] == tempdata[index]['pincode']
      );
      // console.log('*********Started***********');
      // console.log({ arr });

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        // console.log({ arr1 });
        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          // console.log('this might be hand delivery');

          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );
          // console.log({ hasteTapalJPO });
          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval += hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
            // console.log({ anksankhya });
          }
        }
      }
      this.total_thane_pin_sub_count += totalTapalCount;
      this.totalthaneparcel += parcelval;
      this.totalthaneanksankhya += anksankhya;
    }
  }

  getMumbaiPincodeStatement() {
    this.total_mumbai_pin_sub_count = 0;
    this.totalmumbaiparcel = 0;
    this.totalmumbaianksankhya = 0;
    let tempdata = this.uniqueid(
      this.mumbaipincodewisedata,
      (a) => a['pincode']
    );

    // console.log({ tempdata });
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.mumbaipincodewisedata.filter(
        (a) => a['pincode'] == tempdata[index]['pincode']
      );
      // console.log('*********Started***********');
      // console.log({ arr });

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        // console.log({ arr1 });
        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          // console.log('this might be hand delivery');

          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );
          // console.log({ hasteTapalJPO });
          if (hasteTapalJPO.length > 0) {
            let hasteTapalJPOUnique = this.uniqueid(
              hasteTapalJPO,
              (a) => a['distribution_rep']
            );
            // console.log({ hasteTapalJPOUnique });
            parcelval += hasteTapalJPOUnique.length;
            hasteTapalJPOUnique.map((tapal) => {
              let ank = hasteTapalJPO.filter(
                (a) => a['distribution_rep'] === tapal['distribution_rep']
              );
              // console.log({ ank });
              anksankhya += ank.length;
            });
            // console.log({ anksankhya });
          }
        }
      }
      this.total_mumbai_pin_sub_count += totalTapalCount;
      this.totalmumbaiparcel += parcelval;
      this.totalmumbaianksankhya += anksankhya;
    }
  }

  getOtherStatePincodewiseStatement() {
    this.subTotal1 = 0
    this.subTotal2 = 0
    this.countBundleTotal1 = 0
    this.countBooksBundleTotal1 = 0
    this.countBundleTotal2 = 0
    this.countBooksBundleTotal2 = 0
    this.total_pin_sub_count = 0;
    this.totalparcel = 0;
    this.totalanksankhya = 0;
    let tempdata = this.uniqueid(
      this.otherstatepincodewisedata,
      (a) => a['pincode']
    );

    // console.log({ tempdata });
    this.filteredotherstatepincodewisedata = [];
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = this.otherstatepincodewisedata.filter(
        (a) => a['pincode'] == tempdata[index]['pincode']
      );
      // console.log('*********Started***********');
      // console.log({ arr });

      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);
      // console.log({ delivery_mode_unique });

      let totalTapalCount = 0;
      let parcelval = 0;
      let anksankhya = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        // console.log({ arr1 });
        let hasteTapalJPO = [];
        if (arr1[0]['delivery_mode'] === 'टपाल') {
          totalTapalCount = Object.keys(arr1).length;
          // console.log({ totalTapalCount });
        } else if (arr1[0]['delivery_mode'] === 'हस्ते') {
          // console.log('this might be hand delivery');

          hasteTapalJPO = arr1.filter(
            (a) => a['dis_mode'] == 'टपाल' && a['dis_sub_mode'] == 'जी.पी.ओ'
          );
          // console.log({ hasteTapalJPO });
          // if (hasteTapalJPO.length > 0) {
          //   let hasteTapalJPOUnique = this.uniqueid(
          //     hasteTapalJPO,
          //     (a) => a['distribution_rep']
          //   );
          //   // console.log({ hasteTapalJPOUnique });
          //   parcelval += hasteTapalJPOUnique.length;
          //   hasteTapalJPOUnique.map((tapal) => {
          //     let ank = hasteTapalJPO.filter(
          //       (a) => a['distribution_rep'] === tapal['distribution_rep']
          //     );
          //     // console.log({ ank });
          //     anksankhya += ank.length;
          //   });
          //   // console.log({ anksankhya });
          // }

          if (hasteTapalJPO.length > 0) {
  let hasteTapalJPOUnique = this.uniqueid(
    hasteTapalJPO,
    (a) => a['distribution_rep']
  );

  parcelval += hasteTapalJPOUnique.length;  // ✅ FIX

  hasteTapalJPOUnique.forEach((tapal) => {
    let ank = hasteTapalJPO.filter(
      (a) => a['distribution_rep'] === tapal['distribution_rep']
    );

    anksankhya += ank.length;  // OK
  });
}
        }
      }
      // console.log({ totalTapalCount });
      // console.log('*********Ended***********');

      this.filteredotherstatepincodewisedata.push({
        name: tempdata[index]['name'],
        Subscription_Type: tempdata[index]['Subscription_Type'],
        address: tempdata[index]['address'],
        country: tempdata[index]['country'],
        delivery_mode: tempdata[index]['delivery_mode'],
        district: tempdata[index]['district'],
        pincode: tempdata[index]['pincode'],
        state: tempdata[index]['state'],
        sub_perid_to_date: tempdata[index]['sub_perid_to_date'],
        taluka: tempdata[index]['taluka'],
        sub: totalTapalCount,
        parcel: `${parcelval}=${anksankhya}`,
      });

      this.total_pin_sub_count += totalTapalCount;
      this.totalparcel += parcelval;
      this.totalanksankhya += anksankhya;

    }
    // console.log(
    //   'filteredotherstatepincodewisedata',
    // );
    this.filteredotherstatepincodewisedata.sort((a, b) => {
      return a.state.localeCompare(b.state);
    });

    let totalcount = Object.keys(this.filteredotherstatepincodewisedata).length;
    let tempcount = Math.ceil(totalcount / 2);
    let val = 0;
    let a = 0;
    let c = 0;
    for (let i = 0; i < tempcount; i++) {
      val += 2;
      this.pincodewisesubcoutprinting.push({
        state1: '',
        pincode1: 0,
        sub1: 0,
        parcel1: 0,
        state2: '',
        pincode2: 0,
        sub2: 0,
        parcel2: 0,
      });
    }

    let b = Math.ceil(val / 2);
    for (
      let index = 0;
      index < Object.keys(this.filteredotherstatepincodewisedata).length;
      index++
    ) {
      if (index < val) {
        // console.log('val works');
        if (index == a) {
          // console.log('a works', a, index);
          this.pincodewisesubcoutprinting[a]['state1'] =
            this.filteredotherstatepincodewisedata[index]['state'];
          this.pincodewisesubcoutprinting[a]['pincode1'] =
            this.filteredotherstatepincodewisedata[index]['pincode'];
          this.pincodewisesubcoutprinting[a]['sub1'] =
            this.filteredotherstatepincodewisedata[index]['sub'];
          this.pincodewisesubcoutprinting[a]['parcel1'] =
            this.filteredotherstatepincodewisedata[index]['parcel'];
          if (a != tempcount - 1) {
            a += 1;
          }
          this.subTotal1 += Number(this.filteredotherstatepincodewisedata[index]['sub'])
          this.countBundleTotal1 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[0] : "")
          this.countBooksBundleTotal1 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[1] : "")
        } else if (index == b) {
          // console.log('b works', b, c, index);
          this.pincodewisesubcoutprinting[c]['state2'] =
            this.filteredotherstatepincodewisedata[index]['state'];
          this.pincodewisesubcoutprinting[c]['pincode2'] =
            this.filteredotherstatepincodewisedata[index]['pincode'];
          this.pincodewisesubcoutprinting[c]['sub2'] =
            this.filteredotherstatepincodewisedata[index]['sub'];
          this.pincodewisesubcoutprinting[c]['parcel2'] =
            this.filteredotherstatepincodewisedata[index]['parcel'];
          c += 1;
          b += 1;
          this.subTotal2 += Number(this.filteredotherstatepincodewisedata[index]['sub'])
          this.countBundleTotal2 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[0] : "")
          this.countBooksBundleTotal2 += Number(this.filteredotherstatepincodewisedata[index]['parcel'] != undefined && this.filteredotherstatepincodewisedata[index]['parcel'] != null && this.filteredotherstatepincodewisedata[index]['parcel'] != 0 && this.filteredotherstatepincodewisedata[index]['parcel'] != "" ? this.filteredotherstatepincodewisedata[index]['parcel'].split("=")[1] : "")

        }


      }
    }

    // console.log('pincodewisesubcoutprinting', this.pincodewisesubcoutprinting);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  saveSubscriptionPincodeStatewiseEntry() {
    console.log(this.pincodewisesubcoutprinting);
    const filteredData = this.pincodewisesubcoutprinting.map((item) => ({
      issue_date: this.issuedate,
      country: "भारत",
      added_by: 1,
      publish_date: this.convertDateFormat(this.dispatchankDate),
      delivery_mode: this.deleveryMode[0],
      dispatch_date: this.convertDateFormat(this.dispatchankDate),

      state1: item.state1,
      pincode1: item.pincode1,
      no_of_book_bundle1: item.parcel1 != undefined && item.parcel1 != null && item.parcel1 != 0 && item.parcel1 != "" ? item.parcel1.split("=")[1] : "",
      count_bundle1: item.parcel1 != undefined && item.parcel1 != null && item.parcel1 != 0 && item.parcel1 != "" ? item.parcel1.split("=")[0] : "",
      no_subscriber1: item.sub1,

      state2: item.state2,
      pincode2: item.pincode2,
      no_of_book_bundle2: item.parcel2 != undefined && item.parcel2 != null && item.parcel2 != 0 && item.parcel2 != "" ? item.parcel2.split("=")[1] : "",
      count_bundle2: item.parcel2 != undefined && item.parcel2 != null && item.parcel2 != 0 && item.parcel2 != "" ? item.parcel2.split("=")[0] : "",
      no_subscriber2: item.sub2,

      otherStateTotal: this.total_pin_sub_count,
      otherStateGatthe: this.totalparcel,
      otherStatesankhya: this.totalanksankhya,

      mumbaiPincodeWiseTotal: this.total_mumbai_pin_sub_count,
      mumbaiGatthe: this.totalmumbaiparcel,
      mumbaisankhya: this.totalmumbaianksankhya,

      thanePincodeWiseTotal: this.total_thane_pin_sub_count,
      thaneGatthe: this.totalthaneparcel,
      thanesankhya: this.totalthaneanksankhya,

      districtWiseTotal: this.total_dist_pin_sub_count,
      districtWiseGatthe: this.totaldistparcel,
      districtWisesankhya: this.totaldistanksankhya,

      allAdditionTotal: Number(this.total_pin_sub_count) + Number(this.total_mumbai_pin_sub_count) + Number(this.total_thane_pin_sub_count) + Number(this.total_dist_pin_sub_count),
      allAdditionGatthe: Number(this.totalparcel) + Number(this.totalmumbaiparcel) + Number(this.totalthaneparcel) + Number(this.totaldistparcel),
      allAdditionsankhya: Number(this.totalanksankhya) + Number(this.totalmumbaianksankhya) + Number(this.totalthaneanksankhya) + Number(this.totaldistanksankhya),
      allDistributerId1:item.id1,
      allDistributerId2:item.id2
    }));
    console.log(filteredData);
    this.service.savePincodeStatewiseStatement(filteredData).subscribe((data) => {
      alert('Pincodewise Statements Save Successfully!');
    });
  }
  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  convertDateFormat1(dateStr: string): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  }

  deletePincodewiseStatementList() {
    const request = {
      ids: this.selectedIds
    }
    this.service.deleteOtherPincodewiseStatement(request).subscribe((data: any) => {

      alert(data.message);
      this.getOtherStatePincodewiseStatementList();
    });
  }


  checkAll = false;
  masterSelected: boolean = false;
  selectedIds: any = ""
  deleteDistrictwiseStatemet: any = true;
  checkUncheckAll() {
    this.selectedIds = ""
    this.checkAll = !this.checkAll;
    this.pincodewisesubcoutprinting.forEach(item => item.selected = this.checkAll);

    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    // alert(this.selectedIds)
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
  }
  isAllSelected() {
    this.selectedIds = ""
    this.masterSelected = this.pincodewisesubcoutprinting.every(item => item.selected);
    this.pincodewisesubcoutprinting.forEach((element: any) => {
      if (element.selected) {
        if (this.selectedIds == "") {
          this.selectedIds = element.id
        } else {
          this.selectedIds = this.selectedIds + "," + element.id
        }
      }

    });
    if (this.selectedIds == "") {
      this.deleteDistrictwiseStatemet = true;
    } else {
      this.deleteDistrictwiseStatemet = false;
    }
    // alert(this.selectedIds)
  }
  subTotal1: any = 0
  subTotal2: any = 0
  countBundleTotal1: any = 0
  countBooksBundleTotal1: any = 0
  countBundleTotal2: any = 0
  countBooksBundleTotal2: any = 0
  totalCalculatedValue: any = 0
  totalCalculatedGatthaValue: any = 0
  totalCalculatedGParcelValue: any = 0
  getOtherStatePincodewiseStatementList() {
    this.pincodewisesubcoutprinting = []
    const request = {
      issue_date: this.issuedate,
      country: "भारत",
    }
    this.service.getOtherStatePincodewiseStatementList(request).subscribe((data: any) => {
      this.pincodewisesubcoutprinting = data;

      //parprant 
      this.total_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].otherStateTotal),
        this.totalparcel = Number(this.pincodewisesubcoutprinting[0].otherStateGatthe),
        this.totalanksankhya = Number(this.pincodewisesubcoutprinting[0].otherStatesankhya),


        ///Mumbai Total
        this.total_mumbai_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].mumbai_total),
        this.totalmumbaiparcel = Number(this.pincodewisesubcoutprinting[0].mumbaiGatthe),
        this.totalmumbaianksankhya = Number(this.pincodewisesubcoutprinting[0].mumbaisankhya),

        ///Thane Total
        this.total_thane_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].thanePincodeWiseTotal),
        this.totalthaneparcel = Number(this.pincodewisesubcoutprinting[0].thaneGatthe),
        this.totalthaneanksankhya = Number(this.pincodewisesubcoutprinting[0].thanesankhya),

        /// District wise total
        this.total_dist_pin_sub_count = Number(this.pincodewisesubcoutprinting[0].districtWiseTotal),
        this.totaldistparcel = Number(this.pincodewisesubcoutprinting[0].districtWiseGatthe),
        this.totaldistanksankhya = Number(this.pincodewisesubcoutprinting[0].districtWisesankhya),



        ////total calculated
        this.subTotal1 = Number(this.pincodewisesubcoutprinting[0].prantwise_total1)
      this.subTotal2 = Number(this.pincodewisesubcoutprinting[0].prantwise_total2)

      this.countBundleTotal1 = Number(this.pincodewisesubcoutprinting[0].count_bundle_total1)
      this.countBooksBundleTotal1 = Number(this.pincodewisesubcoutprinting[0].count_books_bundle_total1)
      this.countBundleTotal2 = Number(this.pincodewisesubcoutprinting[0].count_bundle_total2)
      this.countBooksBundleTotal2 = Number(this.pincodewisesubcoutprinting[0].count_books_bundle_total2)
      this.totalCalculatedValue = Number(this.pincodewisesubcoutprinting[0].allAdditionTotal)
      this.totalCalculatedGatthaValue = Number(this.pincodewisesubcoutprinting[0].allAdditionGatthe)
      this.totalCalculatedGParcelValue = Number(this.pincodewisesubcoutprinting[0].allAdditionsankhya)

    });
  }
  total: Number
  
  //Old Correct Code 
//   get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement() {
//     // this.filtereddistrictwisesubcout = []
//     const request = {
//       "issue_date": this.issuedate,
//       "countryName": this.country[0],
//       "stateName": this.state,
//       "distributionMode": "",
//       "subDistributionMode": "",
//       "districtName": "",
//       "talukaName": "",
//       "pincode": "",
//       "isOtherPincodeWise": "YES"
//     }
//     this.service.get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement(request).subscribe((data: any) => {
//       let dataList = data.data;
//       this.calculation()
//       console.log(this.pincodewisesubcoutprinting)
//       const districtSummary: any = {};
//       let dataList1 = dataList;
//       // dataList.forEach(item => {
//       //   const { state, district, taluka, prati, pincode,id } = item;

//       //   // Only process if state is not "महाराष्ट्र"
//       //   if (state !== "महाराष्ट्र") {
//       //     // if (!districtSummary[pincode]) {
//       //     districtSummary[state] = {
//       //       district: district,
//       //       talukaCount: 0,
//       //       pratiSum: 0,
//       //       pincode: pincode,
//       //       state: state,
//       //       id:id
//       //     };
//       //     // }

//       //     districtSummary[state].talukaCount += 1; // Count every record (even if taluka name is same)
//       //     districtSummary[state].pratiSum += Number(prati);
//       //   }
//       // });

// dataList.forEach(item => {
//   const { state, district, taluka, prati, pincode, id } = item;

//   // Only process if state is not महाराष्ट्र
//   if (state !== "महाराष्ट्र") {

//     if (!districtSummary[pincode]) {
//       districtSummary[pincode] = {
//         district: district,
//         talukaCount: 0,
//         pratiSum: 0,
//         pincode: pincode,
//         state: state,
//         id: id
//       };
//     }

//     districtSummary[pincode].talukaCount += 1;
//     districtSummary[pincode].pratiSum += Number(prati);
//   }
// });


//       // Convert to list
//       const districtWiseList = Object.values(districtSummary).map((entry: any) => ({
//         district: entry.district,
//         talukaCount: entry.talukaCount,
//         pratiSum: entry.pratiSum,
//         parcel: `${entry.talukaCount}=${entry.pratiSum}`,
//         pincode: entry.pincode,
//         state: entry.state,
//         id:entry.id
//       }));


//       // Step 1: Create a map from districtWiseList
//       const districtMap = new Map<string, any>();

//       districtWiseList.forEach(entry => {
//         districtMap.set(entry.pincode, {
//           talukaCount: entry.talukaCount,
//           pratiSum: entry.pratiSum,
//           parcel: entry.parcel,
//           state: entry.state,
//           id:entry.id
//         });
//       });

//       // Step 2: Merge into filtereddistrictwisesubcout
//       let filtereddistrictwisesubcout1 = this.pincodewisesubcoutprinting.map(item => {
//         // Get parcel for taluka1
//         const match1 = districtMap.get(item.pincode1);
//         const parcel1 = match1?.parcel || "0=0";
//         const id1 = match1?.id;

//         // Get parcel for taluka2
//         const match2 = districtMap.get(item.pincode2);
//         const parcel2 = match2?.parcel || "0=0";
//         const id2 = match2?.id;


//         return {
//           ...item,
//           parcel1,
//           parcel2,
//           id1,
//           id2
//         };
//       });


//       // this.total_sub_count = filtereddistrictwisesubcout1.reduce((sum, item) => {
//       //   return sum + Number(item.sub);
//       // }, 0);
//       this.totalparcel = filtereddistrictwisesubcout1.reduce((sum, item) => {
//         return sum + Number(item.parcel1.split("=")[0]) + Number(item.parcel2.split("=")[0]);
//       }, 0);
//       this.totalanksankhya = filtereddistrictwisesubcout1.reduce((sum, item) => {
//         return sum + Number(item.parcel1.split("=")[1]) + Number(item.parcel2.split("=")[1]);
//       }, 0);
//       this.pincodewisesubcoutprinting = filtereddistrictwisesubcout1;
//       console.log(this.pincodewisesubcoutprinting);

//       let totalValueArray = data.data1;
//       this.total_dist_pin_sub_count = Number(totalValueArray[0].DIST_VARGANIDAR_ANKHYA)
//       this.totaldistanksankhya= Number(totalValueArray[0].DIST_PARCEL)
//       this.totaldistparcel  = Number(totalValueArray[0].DIST_PARCEL_SANKHYA)

//       this.total_thane_pin_sub_count = Number(totalValueArray[0].THANE_VARGANIDAR_SANKHYA)
//       this.totalthaneanksankhya  = Number(totalValueArray[0].THANE_TOTAL_PARCEL)
//       this.totalthaneparcel= Number(totalValueArray[0].THANE_PARCEL_SANKHYA)

//       this.total_mumbai_pin_sub_count = Number(totalValueArray[0].MUMBAI_VARGANIDAR_SANKHYA)
//       this.totalmumbaianksankhya = Number(totalValueArray[0].MUMBAI_TOTAL_PARCEL)
//       this.totalmumbaiparcel = Number(totalValueArray[0].MUMBAI_PARCEL_SANKHYA)



//     });


//   }

get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement() {

  const request = {
    issue_date: this.issuedate,
    countryName: this.country[0],
    stateName: this.state,
    distributionMode: "",
    subDistributionMode: "",
    districtName: "",
    talukaName: "",
    pincode: "",
    isOtherPincodeWise: "YES"
  };

  this.service
    .get_list_All_Distributer_Copies_Total_For_Other_State_Pincodewise_Statement(request)
    .subscribe((data: any) => {

      let dataList = data.data;

      this.calculation(); // OLD LOGIC

      const districtSummary: any = {};

      // ✅ Step 1: Create summary (NO CHANGE)
      dataList.forEach(item => {
        const { state, district, prati, pincode, id } = item;

        if (state !== "महाराष्ट्र") {

          if (!districtSummary[pincode]) {
            districtSummary[pincode] = {
              district: district,
              talukaCount: 0,
              pratiSum: 0,
              pincode: pincode,
              state: state,
              id: id
            };
          }

          districtSummary[pincode].talukaCount += 1;
          districtSummary[pincode].pratiSum += Number(prati);
        }
      });

      // ✅ Step 2: Convert to list
      const districtWiseList = Object.values(districtSummary).map((entry: any) => ({
        district: entry.district,
        talukaCount: entry.talukaCount,
        pratiSum: entry.pratiSum,
        parcel: `${entry.talukaCount}=${entry.pratiSum}`,
        pincode: entry.pincode,
        state: entry.state,
        id: entry.id
      }));

      // ✅ Step 3: Map
      const districtMap = new Map<string, any>();
      districtWiseList.forEach(entry => {
        districtMap.set(entry.pincode, entry);
      });

      // ✅ Step 4: Merge with OLD UI DATA (FIXED sub1/sub2/state)
      let filtereddistrictwisesubcout1 = this.pincodewisesubcoutprinting.map(item => {

        const match1 = districtMap.get(item.pincode1);
        const match2 = districtMap.get(item.pincode2);

        return {
          ...item,

          parcel1: match1 ? match1.parcel : "0=0",
          parcel2: match2 ? match2.parcel : "0=0",

          sub1: match1 ? match1.talukaCount : item.sub1 || 0, // ✅ FIX
          sub2: match2 ? match2.talukaCount : item.sub2 || 0, // ✅ FIX

          state1: match1 ? match1.state : item.state1 || '', // ✅ FIX
          state2: match2 ? match2.state : item.state2 || '', // ✅ FIX

          id1: match1?.id,
          id2: match2?.id
        };
      });

      // ✅ Step 5: ADD MISSING PINCODE (IMPORTANT FIX 🔥)
      const existingPincodes = new Set(
        filtereddistrictwisesubcout1.flatMap(item => [item.pincode1, item.pincode2])
      );

      districtWiseList.forEach((entry: any) => {
        if (!existingPincodes.has(entry.pincode)) {

          // 👉 PUSH NEW ROW (462026 will come here)
          filtereddistrictwisesubcout1.push({
            state1: entry.state,
            pincode1: entry.pincode,
            sub1: entry.talukaCount,   // ✅ IMPORTANT
            parcel1: entry.parcel,

            state2: '',
            pincode2: '',
            sub2: 0,
            parcel2: "0=0",

            id1: entry.id,
            id2: null
          });
        }
      });

      // ✅ Step 6: TOTALS (FIXED परप्रांत एकूण 🔥)
      this.totalparcel = 0;
      this.totalanksankhya = 0;
      // this.total_pin_sub_count = 0;

      // filtereddistrictwisesubcout1.forEach(item => {

      //   const p1 = item.parcel1 ? item.parcel1.split("=") : [0, 0];
      //   const p2 = item.parcel2 ? item.parcel2.split("=") : [0, 0];

      //   this.totalparcel += Number(p1[0]) + Number(p2[0]);
      //   this.totalanksankhya += Number(p1[1]) + Number(p2[1]);

      //   // ✅ MAIN FIX FOR परप्रांत एकूण
      //   this.total_pin_sub_count += Number(item.sub1 || 0) + Number(item.sub2 || 0);
      // });

      // ✅ Step 6: TOTALS (CORRECTED)
// this.totalparcel = 0;
// this.totalanksankhya = 0;

// ❌ DON'T calculate total_pin_sub_count here
// this.total_pin_sub_count = 0;

let uniquePincodeSet = new Set<string>();
let correctSubTotal = 0;

filtereddistrictwisesubcout1.forEach(item => {

  const p1 = item.parcel1 ? item.parcel1.split("=") : [0, 0];
  const p2 = item.parcel2 ? item.parcel2.split("=") : [0, 0];

  this.totalparcel += Number(p1[0]) + Number(p2[0]);
  this.totalanksankhya += Number(p1[1]) + Number(p2[1]);

  // ✅ FIX: count UNIQUE pincodes only once
  if (item.pincode1 && !uniquePincodeSet.has(item.pincode1)) {
    uniquePincodeSet.add(item.pincode1);
    correctSubTotal += Number(item.sub1 || 0);
  }

  if (item.pincode2 && !uniquePincodeSet.has(item.pincode2)) {
    uniquePincodeSet.add(item.pincode2);
    correctSubTotal += Number(item.sub2 || 0);
  }
});

// ✅ FINAL CORRECT TOTAL (परप्रांत एकूण / वर्गणीदार संख्या)
this.total_pin_sub_count = correctSubTotal;

      // ✅ FINAL ASSIGN
      this.pincodewisesubcoutprinting = filtereddistrictwisesubcout1;

      // ====================
// Recalculate ONLY subTotal2
// ====================

this.subTotal2 = 0;

// if same pincode appears twice, count only once
const uniqueRightPincode = new Set<string>();

this.pincodewisesubcoutprinting.forEach((item: any) => {

  if (
      item.pincode2 &&
      item.sub2 &&
      !uniqueRightPincode.has(item.pincode2.toString())
  ) {

      uniqueRightPincode.add(item.pincode2.toString());

      this.subTotal2 += Number(item.sub2);
  }

});

      // ✅ Step 7 Footer (UNCHANGED)
      let totalValueArray = data.data1;

      this.total_dist_pin_sub_count = Number(totalValueArray[0].DIST_VARGANIDAR_ANKHYA);
      this.totaldistanksankhya = Number(totalValueArray[0].DIST_PARCEL);
      this.totaldistparcel = Number(totalValueArray[0].DIST_PARCEL_SANKHYA);

      this.total_thane_pin_sub_count = Number(totalValueArray[0].THANE_VARGANIDAR_SANKHYA);
      this.totalthaneanksankhya = Number(totalValueArray[0].THANE_TOTAL_PARCEL);
      this.totalthaneparcel = Number(totalValueArray[0].THANE_PARCEL_SANKHYA);

      this.total_mumbai_pin_sub_count = Number(totalValueArray[0].MUMBAI_VARGANIDAR_SANKHYA);
      this.totalmumbaianksankhya = Number(totalValueArray[0].MUMBAI_TOTAL_PARCEL);
      this.totalmumbaiparcel = Number(totalValueArray[0].MUMBAI_PARCEL_SANKHYA);

    });
}

  calculation() {
    this.getOtherStatePincodewiseStatement();
    this.getMumbaiPincodeStatement();
    this.getThanePincodeStatement();
    this.getDistrictwiseStatement();
  }



}
